/**
 * Created by christiancueni on 28/06/18.
 * Copyright (c) 2018 ITerativ GmbH. All rights reserved.
 */

import { Action } from '@ngrx/store';

import {AppActionTypes} from './app.actions';

export interface NativeAppState {
    online: boolean,
    hasPush: boolean
}

export const initialNativeAppState: NativeAppState = {
    online: true,
    hasPush: false
};

export function reducer(state = initialNativeAppState, action: Action): NativeAppState {
    switch (action.type) {
        case AppActionTypes.APP_SET_ONLINE:
            return Object.assign({}, state, {
                online: true
            });

        case AppActionTypes.APP_SET_OFFLINE:
            return Object.assign({}, state, {
                online: false
            });

        case AppActionTypes.APP_HAS_PUSH:
            return Object.assign({}, state, {
                hasPush: true
            });

        case AppActionTypes.APP_NO_PUSH:
            return Object.assign({}, state, {
                hasPush: false
            });

        default: {
            return state;
        }
    }
}

// getters for state members

export const getOnline = (state: NativeAppState) => state.online
export const getPush = (state: NativeAppState) => state.hasPush;

